export default __webpack_public_path__ + "static/media/image-20.da2ec81b.png";